export default {
  getQuestionsList:(state) => state.questionsList,
  getMakeQuestion:(state) => state.makeQuestion,
  getPagination:(state) => state.pagination
}